import { toast } from 'sonner'
import Button from '../common/form/inputs/Button'
import { useManageCandidateStore } from '../../components/manageRole/stateStore/manageCandidateStore'
import { PresentCandidateValues } from '../../api/role/models/CandidateDto'

interface Props {
    roleId: string
    candidateId: string
}

export function SaveToRoleControls({ candidateId }: Props) {
    const candidates = useManageCandidateStore((s) => s.candidates)
    const candidate = candidates.find(
        (c) => c.candidatePersonId === candidateId,
    )
    const updatePresentCandidateStore = useManageCandidateStore(
        (s) => s.updatePresentForCandidate,
    )

    const updatePresentState = (newState?: PresentCandidateValues) => {
        updatePresentCandidateStore(candidateId, newState).catch((error) => {
            console.error('Failed to update present value for candidate', error)
            toast.error('Could not update this candidate. Please try again.')
        })
    }

    return (
        <div className="flex gap-2">
            {candidate?.present === PresentCandidateValues.YES && (
                <Button
                    onClick={() => {
                        updatePresentState(undefined)
                    }}
                    type="button"
                    style="primary"
                    size="small"
                    classes="bg-green-600 hover:bg-green-700 text-white"
                >
                    Saved to Role
                </Button>
            )}
            {!candidate?.present && (
                <Button
                    onClick={() => {
                        updatePresentState(PresentCandidateValues.YES)
                    }}
                    type="button"
                    style="primary"
                    size="small"
                >
                    Save to Role
                </Button>
            )}
            {(!candidate?.present ||
                candidate?.present === PresentCandidateValues.YES) && (
                <Button
                    onClick={() => {
                        updatePresentState(PresentCandidateValues.NO)
                    }}
                    type="button"
                    style="mild-danger"
                    size="small"
                >
                    Hide for this Role
                </Button>
            )}
            {candidate?.present === PresentCandidateValues.NO && (
                <Button
                    onClick={() => {
                        updatePresentState(undefined)
                    }}
                    type="button"
                    style="secondary"
                    size="small"
                >
                    Undo Hide
                </Button>
            )}
        </div>
    )
}
